// extracted by mini-css-extract-plugin
export default {"video":"FlvPlayer_video__eE17g"};